import { confirmAlert } from 'react-confirm-alert';

import type {
  ListId,
  // CardId,
} from '@vlabs/api/point-api/model';

import { DetachCardFromListConfirmation } from './DetachCardFromListConfirmation';

interface ConfirmDetachFromListProps {
  listId: ListId;
  // cardId: CardId;
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
  async?: boolean;
}

export const confirmDetachCardFromList = ({
  // cardId,
  listId,
  onConfirm,
  onReject = undefined,
  async = false,
}: ConfirmDetachFromListProps): void | Promise<void> => {
  const buildAlert = ($onConfirm?: VoidFunction, $onReject?: VoidFunction) => confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DetachCardFromListConfirmation
          // cardId={cardId}
          listId={listId}
          onConfirm={() => {
            $onConfirm?.();
            onClose();
          }}
          onReject={() => {
            $onReject?.();
            onClose();
          }}
        />
      );
    },
  });
  if (!async) return void buildAlert(onConfirm, onReject);

  return new Promise((resolve, reject) => {
    const $onConfirm = () => {
      onConfirm?.();
      resolve();
    };
    const $onReject = () => {
      onReject?.();
      reject();
    };
    buildAlert($onConfirm, $onReject);
  });
};
